import { Injectable } from '@angular/core';

import { environment } from '../../../environments/environment';
import { AppConfig } from '../models/app-config.model';

/**
 * Loads the runtime configuration file named by `environment.configFile`
 */
@Injectable({
  providedIn: 'root'
})
export class ConfigInitService {
  private configData?: AppConfig;

  /**
   * Reads and parses the runtime configuration file
   *
   * @returns {Promise<AppConfig>} Resolves with the parsed configuration, rejects with a message when the file cannot be loaded
   */
  public getConfig(): Promise<AppConfig> {
    const jsonFile = environment.configFile;

    return new Promise((resolve, reject) => {
      const response = this.GetSync(jsonFile);

      if (response) {
        this.configData = JSON.parse(response) as AppConfig;
        resolve(this.configData);
      } else {
        reject(`Could not load file '${jsonFile}': ${JSON.stringify(response)}`);
      }
    });
  }

  /**
   * Fetches a file synchronously, so the configuration is available before any request is made
   *
   * @param {string} url Path of the file to fetch
   *
   * @returns {string | null} The response body on HTTP 200, otherwise `null`
   */
  public GetSync(url: string): string | null {
    const xmlhttp = new XMLHttpRequest();

    xmlhttp.open('GET', url, false);
    xmlhttp.overrideMimeType('application/json');
    xmlhttp.send();
    if (xmlhttp.status == 200) {
      return xmlhttp.responseText;
    } else {
      return null;
    }
  }

  /**
   * @returns {string} Path of the configuration file for the running environment
   */
  private getConfigFile(): string {
    return environment.configFile;
  }
}
